import React, { useEffect } from 'react'

import api from '@/api'
import { useReadyTitleBlinking } from '@/views/hooks/useReadyTitleBlinking'

export const useWaitForTranscriptGeneration = ({
  interviewId,
  isFullTranscriptGenerating,
  setIsFullTranscriptGenerating,
}: {
  interviewId: string
  isFullTranscriptGenerating: boolean
  setIsFullTranscriptGenerating: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const { startReadyTitleBlinking } = useReadyTitleBlinking()

  useEffect(() => {
    if (!isFullTranscriptGenerating) {
      return
    }

    console.log('Start waiting for transcript generation')
    const interval = setInterval(async () => {
      const newInterview = (await api.getInterview(interviewId)).data.interview
      if (newInterview.isFullTranscriptGenerating === false) {
        console.log('Transcript generation finished', {
          newInterview,
        })
        clearInterval(interval)
        setIsFullTranscriptGenerating(false)

        console.log('Transcript generation finished')
        startReadyTitleBlinking()
      }
    }, 20000)
    return () => clearInterval(interval)
  }, [interviewId, isFullTranscriptGenerating])
}
